export default __webpack_public_path__ + "static/images/logo-satispay-wide-02cbb55c94e38ec8231e33c84d5f1090.png";